import rest from "../script/rest";
import commonUtils from "../script/utils/commonUtils";

class ReportRest {

    async getReport(request, entry) {
        const url = "/rest/report/getReport";
        const response = await rest.file(url, "request.json", JSON.stringify(request));
        const fileName = this.buildReportFileName("WWA", entry, "report.odt");

        await this.downloadResponse(response, fileName);
    }

    async getIxusReport(request, entry) {
        const url = "/rest/report/ixusReport"
            + "?entryId=" + entry.id;
        const response = await rest.file(url, "request.json", JSON.stringify(request));
        const fileName = this.buildReportFileName("Arbeitsschutz", entry, "Gefahrbereich.odt");

        await this.downloadResponse(response, fileName);
    }

    async downloadResponse(response, fileName) {
        const blob = await response.blob();
        const fileUrl = window.URL.createObjectURL(blob);
        commonUtils.download(fileUrl, fileName);
        setTimeout(() => window.URL.revokeObjectURL(fileUrl), 1000);
    }

    buildReportFileName(prefix, entry, fallbackFileName) {
        const siteName = this.getSiteName(entry);

        if(!siteName) {
            return fallbackFileName;
        }

        const sanitizedSiteName = siteName
            .replace(/[\\/:*?"<>|]/g, "_")
            .trim();

        const date = this.formatDate(new Date());

        return `${prefix}_${sanitizedSiteName}_${date}.odt`;
    }

    getSiteName(entry) {
        return entry?.siteName
            || entry?.site?.name
            || entry?.site?.siteName
            || entry?.siteNum;
    }

    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}${month}${day}`;
    }
}

const reportRest = new ReportRest();
window.reportRest = reportRest;
export default reportRest;